import { TableCellRendererProps } from "@vuu-ui/vuu-table-types";
import { MouseEventHandler, useCallback } from "react";
import { useComponentCssInjection } from "@salt-ds/styles";
import { useWindow } from "@salt-ds/window";

import iconButtonCellCss from "./IconButtonCell.css";
import { useRowAction } from "../../table-provider/TableProvider";
import { Button } from "@salt-ds/core";

const classBase = "vuuIconButtonCell";

/**
 * To assign an icon to the cell, give the columndescriptor
 * a className. In css, assign an icon variable to --vuu-svg-icon.
 */
export const IconButtonCell = ({ column, dataRow }: TableCellRendererProps) => {
  const targetWindow = useWindow();
  useComponentCssInjection({
    testId: "vuu-iconbutton-cell",
    css: iconButtonCellCss,
    window: targetWindow,
  });

  const actionHandler = useRowAction(column.name);
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (evt) => {
      evt.stopPropagation();
      actionHandler(column.name, dataRow);
    },
    [actionHandler, column, dataRow],
  );

  return (
    <Button
      appearance="transparent"
      className={classBase}
      data-embedded
      data-icon
      onClick={handleClick}
    />
  );
};
